import React, { useState, useEffect } from 'react';
import { Dropdown, Tabs, Tab, Pagination } from 'carbon-components-react';
import moment from 'moment';

import QueueTable from './QueueTable';
import mockedData from './mock.json';
import * as configConst from "../../config/Constants";
import i18n from "../../i18n";
require("./_queue-details.scss");



const QueueDetails = (props) => {
    const [queueNames, setQueueNames] = useState([]);

    const [completedQueueheaders] = useState([
        {
            key: 'item_id',
            header: 'Item ID',
            hidden: false
        },
        {
            key: 'item_key',
            header: 'Item key',
            hidden: false
        }, {
            key: 'duration',
            header: 'Duration (minutes)',
            hidden: false
        }, {
            key: 'completed_time',
            header: 'Completion time',
            hidden: false
        }
    ]);
    const [runningQueueHeaders] = useState([
        {
            key: 'item_id',
            header: 'Item ID',
            hidden: false
        },
        {
            key: 'item_key',
            header: 'Item key',
            hidden: false
        }, {
            key: 'duration',
            header: 'Duration',
            hidden: false
        }, {
            key: 'locked_time',
            header: 'Start time',
            hidden: false
        }
    ]);
    const [pendingQueueHeaders] = useState([
        {
            key: 'item_id',
            header: 'Item ID',
            hidden: false
        },
        {
            key: 'item_key',
            header: 'Item key',
            hidden: false
        }, {
            key: 'loaded_time',
            header: 'Load time',
            hidden: false
        }
    ]);
    let exceptionHeaders = [
        {
            key: 'item_id',
            header: 'Item ID',
            hidden: false
        },
        {
            key: 'item_key',
            header: 'Item key',
            hidden: false
        },
        {
            key: 'type',
            header: 'Exception type',
            hidden: false
        },
        {
            key: 'incidentNumber',
            header: 'Incident no',
            hidden: false
        }, {
            key: 'incidentSysId',
            header: 'Sys Id',
            hidden: true
        }, {
            key: 'incidentURL',
            header: 'Incident URL',
            hidden: true
        }, {
            key: 'queueName',
            header: 'Queue Name',
            hidden: true
        }, {
            key: 'incidentCreatedAt',
            header: 'Created At',
            hidden: true
        }, {
            key: 'client',
            header: 'Client',
            hidden: true
        }, {
            key: 'appHost',
            header: 'App Host',
            hidden: true
        }
    ]

    const [exceptionQueueHeaders] = useState(exceptionHeaders);
    const [deferredQueueHeaders] = useState([
        {
            key: 'item_id',
            header: 'Item ID',
            hidden: false
        },
        {
            key: 'deferred_time',
            header: 'Deferred until',
            hidden: false
        }
    ]);
    const [rows, setRows] = useState([]);
    const [fullRows, setFullRows] = useState([]);

    useEffect(() => {
        getUniqueQueueNames();
        prepareRowData();
    }, [props?.queueData])

    function modifyData(data) {
        let modifiedElement;
        let result = data?.map((element, index) => {
            modifiedElement = element._source;
            modifiedElement.id = index + 1;
            modifiedElement.status = element?.fields?.status[0];
            modifiedElement.duration = (Math.round(element?.fields?.duration * 100) / 100).toFixed(2);
            modifiedElement.incidentNumber = element?._source?.incident_id ? element?._source?.incident_id : '-';
            modifiedElement.loaded_time = element?._source?.loaded_time && moment(element?._source?.loaded_time).format('YYYY-MM-DD HH:mm');
            modifiedElement.locked_time = element?._source?.locked_time && moment(element?._source?.locked_time).format('YYYY-MM-DD HH:mm');
            modifiedElement.deferred_time = element?._source?.deferred_time && moment(element?._source?.deferred_time).format('YYYY-MM-DD HH:mm');
            modifiedElement.completed_time = element?._source?.completed_time && moment(element?._source?.completed_time).format('YYYY-MM-DD HH:mm');
            modifiedElement.incidentSysId = element?._source?.incident_sys_id ? element?._source?.incident_sys_id : '';
            modifiedElement.queueName = element?._source?.queue_name ? element?._source?.queue_name : '';
            modifiedElement.incidentURL = element?._source?.incident_url ? element?._source?.incident_url : '';
            modifiedElement.incidentCreatedAt = element?._source?.inc_created_at ? element?._source?.inc_created_at : '';
            modifiedElement.client = element?._source.party_nm ? element?._source.party_nm : '';
            modifiedElement.appHost = element?._source.app_host_machine_nm ? element?._source.app_host_machine_nm : '';

            console.log(modifiedElement, "modified element");
            return modifiedElement;
        });
        return result;
    }
    function prepareRowData() {
        let data = props?.queueData ? props?.queueData?.hits?.hits : [];
        let result = modifyData(data);
        setRows(result);
        setFullRows(data);
    }

    function getUniqueQueueNames() {
        let data = props?.queueData ? props?.queueData?.hits?.hits : [];
        const unique = [...new Set(data?.map(item => item._source.queue_name))];
        setQueueNames(unique)
    }

    function filterDataWithQueueName(param) {
        let filteredRows = fullRows.filter(function (e) {
            return e?._source?.queue_name === param?.selectedItem;
        });
        filteredRows = modifyData(filteredRows);
        setRows(filteredRows)
    }

    return (
        <div className="automation-queue-details">
            <Dropdown
                ariaLabel="Dropdown"
                id="carbon-dropdown-example"
                items={queueNames}
                label="Queue name"
                titleText="Queue"
                onChange={filterDataWithQueueName}
            />
            <div className="tab-container">
                <Tabs type='container'>
                    <Tab
                        href="#"
                        id="tab-1"
                        label="Completed"
                    >
                        <div className="some-content">
                            <QueueTable rows={rows} headers={completedQueueheaders} status='Completed' />
                        </div>
                    </Tab>
                    <Tab
                        href="#"
                        id="tab-2"
                        label="Running"
                    >
                        <div className="some-content">
                            <QueueTable rows={rows} headers={runningQueueHeaders} status='Running' />
                        </div>
                    </Tab>
                    <Tab
                        href="#"
                        id="tab-3"
                        label='Pending'
                    >
                        <div className="some-content">
                            <QueueTable rows={rows} headers={pendingQueueHeaders} status='Pending' />
                        </div>
                    </Tab>
                    <Tab
                        href="#"
                        id="tab-4"
                        label='Exception'
                    >
                        <div className="some-content">
                            <QueueTable rows={rows} headers={exceptionQueueHeaders} isExpandable={true} status='Failed' workspace={props.workspace} isQueue={true} />
                        </div>
                    </Tab>
                    <Tab
                        href="#"
                        id="tab-5"
                        label='Deferred'
                    >
                        <div className="some-content">
                            <QueueTable rows={rows} headers={deferredQueueHeaders} status='Deferred' />
                        </div>
                    </Tab>
                </Tabs>
            </div>
        </div>
    );
};

export default QueueDetails;
